





















































import { Component, Mixins, Prop } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import ShouninLocalHeader from '../molecules/ShouninLocalHeader.vue'
import ShouninInputForm from '../organisms/ShouninInputForm.vue'
import * as ApiPath from '@/tcw/constant/ApiPath'
import KintaiGetsudoDataView from '@/components/kintai/organisms/KintaiGetsudoDataView.vue'
import KintaiCardList from '@/components/kintai/organisms/KintaiCardList.vue'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'
import Getsudo from '@/tcw/domain/Getsudo'
import { TcwAPIID } from '@/tcw/domain/types'
import ShouninRireki from '@/components/shounin/organisms/ShouninRireki.vue'

@Component({
  components: {
    TcwLayoutBasicTemplate,
    KintaiGetsudoDataView,
    KintaiCardList,
    ShouninLocalHeader,
    ShouninInputForm,
    ShouninRireki
  }
})
export default class ShouninPage extends Mixins(BasePage, DataGetComponent) {
  @Prop({ default: 400 })
  protected height!: number

  protected teishutsu: ApiGeneralSinglePayload = {}

  protected instructionTitle = ''
  protected instructionDescription = ''

  get targetGetsudo(): Getsudo {
    if (this.routeParams.year && this.routeParams.month) {
      // URLパラメータに月度が指定されていた場合(承認対象者の提出情報を確認する場合)
      return Getsudo.of(this.routeParams.year, this.routeParams.month)
    } else {
      // 月度未指定の場合
      return this.currentGetsudo
    }
  }
  get targetIsOwn(): boolean {
    return (
      this.routeParams.teishutsushaId === undefined ||
      String(this.routeParams.teishutsushaId) === String(this.loginUserId)
    )
  }
  get apiPath(): string {
    // 自分の提出情報を見るか、他人のを見るか判定
    if (this.targetIsOwn) {
      console.log('ログインユーザの提出情報を参照')
      return ApiPath.buildPath(ApiPath.Paths.Teishutsu.get, {
        year: this.targetGetsudo.yearValue,
        month: this.targetGetsudo.monthValue
      })
    } else {
      console.log(`${this.routeParams.teishutsushaId}の提出情報を参照`)
      return ApiPath.buildPath(ApiPath.Paths.TeishutsuOther.get, {
        year: this.targetGetsudo.yearValue,
        month: this.targetGetsudo.monthValue,
        userId: this.routeParams.teishutsushaId
      })
    }
  }

  protected get teishutsusha(): ApiGeneralSinglePayload | null {
    const teishutsusha = this.teishutsu?.teishutsusha
    if (teishutsusha && typeof teishutsusha === 'object' && !Array.isArray(teishutsusha)) {
      return teishutsusha
    } else {
      return {}
    }
  }

  protected get teishutsushaId(): TcwAPIID {
    if (
      this.teishutsusha &&
      (typeof this.teishutsusha.id === 'string' || typeof this.teishutsusha.id === 'number')
    ) {
      return this.teishutsusha.id
    } else {
      return null
    }
  }

  protected get isComplete(): boolean {
    return this.teishutsu?.status === '3'
  }

  /**
   * 提出情報取得API実行後処理
   */
  protected responseInitWebApi(response: ApiGeneralSinglePayload): void {
    this.teishutsu = response
  }

  protected async afterProc(): Promise<void> {
    this.outputTeishutsuMessage()
  }
  protected outputTeishutsuMessage(): void {
    if (this.targetIsOwn) {
      switch (this.teishutsu.status) {
        case '0': // 未提出
          this.instructionTitle = '今月分の勤怠が未提出です。'
          this.instructionDescription = '下記を確認して提出してください'
          break
        case '1': // 承認依頼中
          this.instructionTitle = `現在${this.getShouninUserNameStr()}確認中です。`
          if (Number(this.teishutsu.genzaiLevel) === 1) {
            this.instructionDescription = `修正が必要な場合は「取下」を実行してステータスを戻してください`
          }
          break
        case '2': // 総務確認中
          this.instructionTitle = `現在${this.getShouninUserNameStr()}確認中です。`
          break
        case '3': // 完了
          this.instructionTitle = `承認完了しました。`
          break
        case '4': // 再提出
          this.instructionTitle = `勤怠を確認し再提出してください。`
          break
        default:
          break
      }
    } else {
      this.instructionTitle = '承認'
      this.instructionTitle = `下記を確認し「実行」をクリックしてください。問題なければ「承認」を、修正が必要であればコメントを記載し「差戻」をクリックしてください。`
    }
  }
  protected getShouninUserNameStr(): string {
    const shouninUserList = this.teishutsu.shouninUserList as ApiGeneralObjectArrayPayload
    if (!Array.isArray(shouninUserList)) {
      return ''
    }
    return shouninUserList.map(user => user.userName).join(',')
  }
}
